/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const AssignTaskUpdate = lazyLoad(
  () => import('./index'),
  module => module.AssignTaskUpdate
);
